import { useCallback, useState } from "react";
import ContractsService from "../../../services/accounts/contracts";

export const useSearchCustomer = (
  setFieldError: (errorMessages: string[]) => void
) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const [customer, setCustomer] = useState<any>(null);

  const search = useCallback(
    (number: number, onSuccess: ((value: any) => void) | undefined): void => {
      setIsDisabled(true);

      ContractsService.searchCustomerByNumber(number)
        .then((res: any) => {
          setFieldError([]);
          setIsDisabled(false);

          if (res && res.length > 0) {
            setCustomer(res[0]);

            onSuccess && onSuccess(res[0]);
          } else {
            setFieldError(["Customer was not found"]);
            setCustomer(null);
          }
        })
        .catch((error) => {
          setIsDisabled(false);
          setCustomer(null);

          const { response } = error;
          const { data } = response;

          setFieldError([data.title]);
        });
    },
    [setFieldError]
  );

  return { customer, setCustomer, isDisabled, search };
};
